<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="内部供应商报价查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_internal_quote_search")}}</span>
        <VendPurchaseQuoteSearch></VendPurchaseQuoteSearch>
      </el-tab-pane>
      <el-tab-pane label="新建内部供应商报价">
        <span slot="label"><i class="iconfont icon-edit" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_internal_quote_create")}}</span>
        <VendPurchaseQuoteAdd></VendPurchaseQuoteAdd>
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_import")}}</span>
        <VendPurchaseQuoteExport :type_code="'internal'"></VendPurchaseQuoteExport>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VendPurchaseQuoteSearch from "./VendPurchaseQuoteSearch";
import VendPurchaseQuoteAdd from "./VendPurchaseQuoteAdd";
import VendPurchaseQuoteExport from "./VendPurchaseQuoteExport";

export default {
  name: "VendPurchaseQuote",
  components: {
    VendPurchaseQuoteSearch,
    VendPurchaseQuoteAdd,
    VendPurchaseQuoteExport,
  },
  data() {
    return {
      tab_index: 0,
    };
  },
  created() { },
  methods: {},
};
</script>
